import LReport from './src/index.vue'
import Vue from 'vue'
const LReportConstructor = Vue.extend(LReport)

let instance
function $report() {
  Object.defineProperty(Vue.prototype, '$report', {
    get() {
      const $report = (options) => {

        instance = new LReportConstructor({
          propsData: options,
        })

        // TIME：排行榜 STAR：完成榜
        options.rankType ='STAR'

        instance.vm = instance.$mount()
        instance.visible = true
        instance.options = options
        instance.closed = () => {
          instance.visible = false
          instance.vm.$el.remove()
        }
        if (instance.visible) instance.confetti(true)
        document.body.appendChild(instance.vm.$el)
        return instance.vm
      }
      return $report
    },
  })
}

export default $report
